import { Form, Input, Button } from "antd";
import { useEffect } from "react";

function EditParkingBayForm({ initialValues, onSubmit }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  const handleFinish = (values) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={initialValues}
    >
      <Form.Item
        label="Parking Bay Name"
        name="parkingBayName"
        rules={[{ required: true, message: "Please enter parking bay name" }]}
      >
        <Input placeholder="Enter parking bay name" />
      </Form.Item>

      <Form.Item
        label="Latitude"
        name="latitude"
        rules={[{ required: true, message: "Please enter latitude" }]}
      >
        <Input placeholder="Enter latitude" />
      </Form.Item>

      <Form.Item
        label="Longitude"
        name="longitude"
        rules={[{ required: true, message: "Please enter longitude" }]}
      >
        <Input placeholder="Enter longitude" />
      </Form.Item>

      <div style={{ textAlign: "right" }}>
        <Button type="primary" htmlType="submit">
          Update
        </Button>
      </div>
    </Form>
  );
}

export default EditParkingBayForm;
